module.exports = __webpack_public_path__ + "static/media/5.4b7cee05.png";